/**
 * Public host for the Minerva documentation site (Mintlify).
 *
 * This is a product constant, not deployment wiring: every environment serves
 * the same docs host, so it must not come from an environment variable. It was
 * previously supplied per environment through AWS Secrets Manager as
 * `NEXT_PUBLIC_KNOWLEDGE_HUB_URL`, which rotted in prod to the retired
 * `hub.gominerva.com` host (no DNS record left) and was inlined into the client
 * bundle at build time — sending invited users and the sidebar and
 * command-palette docs links to a dead host.
 */
export const DOCS_BASE_URL = 'https://docs.gominerva.com';
